import axios from 'axios';

export const getUser = async (token) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/user`;
    try {
        const response = await axios.get(apiUrl, {
            headers: {
                authorization: `Bearer ${token}`,
            },
        });
        console.log('user')
        console.log(response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching user:', error);
        throw error;
    }
};

export const updateUser = async (token, updates) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/user`;
    try {
        const response = await axios.put(apiUrl, updates, {
            headers: {
                authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error updating user:', error);
        throw error;
    }
};